<template>
  <div id="hangxian">
    <div style="margin-left: 25px;margin-top: 10px;text-align: left;">
      年份：
      <Select v-model="selectYear" style="width:100px" @on-change="changeYear">
        <Option v-for="item in yearList" :value="item" :key="item">{{
          item
        }}</Option>
      </Select>
    </div>
    <table class="layui-hide" id="focastData" lay-filter="focastData"></table>
    <Modal
      v-model="modal"
      title="预报数据管理"
      ok-text="提交"
      fullscreen
      footer-hide
      class-name="focastModel"
      @on-ok="exportData"
      @on-cancel="cancel"
    >
      <div class="editDiv" v-if="modal">
        <Weathermap v-on:getMap="getMap2" id="focastMap"></Weathermap>
        <!-- /////  预报数据修改  /////// -->
        <div class="map_tool" v-show="modal" ref="tabTableDiv">
          <Table
            ref="tabTable"
            :columns="mapColumn"
            :data="mapData"
            max-height="500"
            size="small"
            border
            disabled-hover
            highlight-row
            class="mapTable"
          >
            <template slot-scope="{ row, index }" slot="lng">
              <span v-if="mapData[index].isEdit == false">{{
                mapData[index].lng
              }}</span>
              <Input
                v-else
                v-model="mapData[index].lng"
                style="width: 100%"
                size="small"
              />
            </template>
            <template slot-scope="{ row, index }" slot="lat">
              <span v-if="mapData[index].isEdit == false">{{
                mapData[index].lat
              }}</span>
              <Input
                v-else
                v-model="mapData[index].lat"
                style="width: 100%"
                size="small"
              />
            </template>
            <template slot-scope="{ row, index }" slot="date">
              <span v-if="mapData[index].isEdit == false">{{
                moment(mapData[index].date).format('YYYY-MM-DD HH:mm:ss')
              }}</span>
              <DatePicker  v-else type="datetime"  v-model="mapData[index].date"  style="width: 100%" size="small" transfer></DatePicker>
              <!-- <Input
                v-else
                v-model="mapData[index].date"
                style="width: 100%"
                size="small"
              /> -->
            </template>
            <template slot-scope="{ row, index }" slot="pressure">
              <span v-if="mapData[index].isEdit == false">{{
                Number(mapData[index].pressure).toFixed(2)
              }}</span>
              <Input
                v-else
                v-model="mapData[index].pressure"
                style="width: 100%"
                size="small"
              />
            </template>
            <template slot-scope="{ row, index }" slot="speed">
              <span v-if="mapData[index].isEdit == false">{{
                Number(mapData[index].speed).toFixed(2)
              }}</span>
              <Input
                v-else
                v-model="mapData[index].speed"
                style="width: 100%"
                size="small"
              />
            </template>
            <template slot-scope="{ row, index }" slot="movespeed">
              <span v-if="mapData[index].isEdit == false">{{
                Number(mapData[index].movespeed).toFixed(2)
              }}</span>
              <Input
                v-else
                v-model="mapData[index].movespeed"
                style="width: 100%"
                size="small"
              />
            </template>
            <template slot-scope="{ row, index }" slot="strong">
              <span v-if="mapData[index].isEdit == false">{{
                mapData[index].strong
              }}</span>
              <Input
                v-else
                v-model="mapData[index].strong"
                style="width: 100%"
                size="small"
              />
            </template>
            <template slot-scope="{ row, index }" slot="power">
              <span v-if="mapData[index].isEdit == false">{{
                mapData[index].power
              }}</span>
              <Input
                v-else
                v-model="mapData[index].power"
                style="width: 100%"
                size="small"
              />
            </template>
            <template slot-scope="{ row, index }" slot="action">
              <Button
                type="primary"
                size="small"
                style="margin-right: 5px"
                @click="editPoint(row, index)"
                v-if="!mapData[index].isEdit"
                >编辑</Button
              >
              <Button
                type="primary"
                size="small"
                style="margin-right: 5px"
                @click="pointDefine(row, index)"
                v-else
                >确定</Button
              >
              <Button type="error" size="small" @click="remove(row, index)"
                >删除</Button
              >
            </template>
          </Table>
        </div>
        <div id="Legend">
      <table
        class="leaflet-control-legend leaflet-control"
        style="width: 235px;background: rgb(109, 162, 228);"
      >
        <tbody class="">
          <tr class="">
            <td class="leaflet-control-legend-top-left"></td>
            <td class="leaflet-control-legend-top-center" align="right">
              <div class="leaflet-control-legend-title" align="left">
                预报机构
              </div>
              <div class="leaflet-control-legend-title-down"></div>
            </td>
            <td class="leaflet-control-legend-top-right"></td>
          </tr>
          <tr class="">
            <td class="leaflet-control-legend-mid-left"></td>
            <td
              class="leaflet-control-legend-mid-center"
              style="display: block;"
            >
              <table class="typhoon-legend-main">
                <tbody>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中国"
                          id="China"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">中国</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FF6450">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中国香港"
                          id="HongKong"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">中国香港</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FF66FF">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="日本"
                          id="Japan"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">日本</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#43FF4B">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中国台湾"
                          id="Taiwan"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">中国台湾</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FFA040">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="美国"
                          id="USA"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">美国</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#40DDFF">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="韩国"
                          id="korea"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">韩国</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#669999">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="欧洲"
                          id="Europe"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">欧洲</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#373591">
                        ━ ━
                      </div>
                    </td>
                    <td>
                      <div style="float:left">
                        <input
                          type="checkbox"
                          class="typhoon-legend-input"
                          name="typhoon-legend"
                          value="中大预报"
                          id="zhongda"
                          checked=""
                          @click="addTyphoonForcastdata()"
                        />
                        <div class="typhoon-legend-name">中大预报</div>
                      </div>
                    </td>
                    <td>
                      <div class="typhoon-legend-command" style="color:#FF0000">
                        ━ ━
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td
              class="leaflet-control-legend-mid-center-hid"
              style="display: none;"
            ></td>
            <td class="leaflet-control-legend-mid-right"></td>
          </tr>
          <tr class="">
            <td class="leaflet-control-legend-foot-left"></td>
            <td class="leaflet-control-legend-foot-center"></td>
            <td class="leaflet-control-legend-foot-right"></td>
          </tr>
        </tbody>
      </table>
      </div>
      </div>
    </Modal>
    <Modal
        v-model="importExcel"
        title="预报数据导入"
        :mask-closable="false"
        width="700"
        footer-hide
        class-name="focastModel"
        @on-ok="exportData"
        @on-cancel="cancel"
    >
        <input id="upload" type="file" @change="importfxx(this)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" v-if="importExcel"/>
        <div>
            1. 导入前，建议您 <a href="/static/FpointImport.xlsx" class="btn btn-success btn-xs" target="_blank">下载模板</a> 并详细参阅以下说明；<br>
            2. 按照指定格式整理好 Excel 文件；<br>
                a. 发布时间：必填，路径系列预测点发布时间应一致（格式：2018072402，精确到时的10位数字）；<br>
                b. 预达时间：必填，预计台风中心到达的时间（格式：2018072402，精确到时的10位数字）；<br>
                c. 经度、纬度、中心气压、风速，必填，均为数值，建议只保留小数点后不超过2位；<br>
                d. 移动方向：非必填，示例（北北西）；<br>
                e. 七级风圈半径、十级风圈半径：非必填，均为数值，建议只保留小数点后不超过2位。<br>
            3. 所有列请勿填入单位，请勿改动各列顺序；<br>
            4. 第一行为表头，第二行为示例（跳过不导入），数据将从第三行开始导入；<br>
            5. 在 Excel 中，清除 Excel 格式（带格式可能导入失败）；<br>
            6. 导入 Excel 文件时在收到返回提示前请勿进行其他操作。<br>
        </div>
    </Modal>
  </div>
</template>

<script type="text/ecmascript-6">
import moment from "moment";
import Weathermap from "@/map/weathermap.vue";
import typhoonImg from "../assets/img/typhoon.gif";
export default {
  components: {
    Weathermap
  },
  data() {
    return {
      moment: moment,
      Mondata: [],
      tableData: [],
      selectYear: Number(moment().format('YYYY')),
      yearList: [],
      modal: false,
      map2: null,
      typhoonPointLayer2: null, //台风实况点图层
      typhoonLineLayer2: null, //台风实况线图层
      typhoonYubaoPointLayer2: null, //台风预报点图层
      typhoonYubaoLineLayer2: null, //台风预报线图层
      typhoonFengquanLayer2: null, //风圈图层
      typhoonContainer2: null, //台风图层容器
      tfid: null,
      ybList: null,
      pointLayer: null,
      drawPoint: null,
      savePoint: null, //暂存的点,
      selFeatureId: null,
      isDrawPointActive: false,
      mapColumn: [
        {
            title: '经度',
            slot: 'lng',
            minWidth: 110
        },
        {
            title: '纬度',
            slot: 'lat',
            minWidth: 110
        },
        {
            title: '到达时间',
            slot: 'date',
            minWidth: 170
        },
        {
            title: '中心气压',
            slot: 'pressure',
            minWidth: 100
        },
        {
            title: '风速',
            slot: 'speed',
            minWidth: 100
        },
        {
            title: '移动速度',
            slot: 'movespeed',
            minWidth: 100
        },
        {
            title: '风力',
            slot: 'power',
            minWidth: 100
        },
        {
            title: '风力等级描述',
            slot: 'strong',
            minWidth: 150
        },
        {
            title: 'Action',
            slot: 'action',
            width: 170,
            fixed: 'right',
            align: 'center',
            renderHeader: (h, params) => {
                return h('div', [
                    h(
                        'Button',
                        {
                            props: {
                                type: 'warning',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.addMapData(h, params)
                                }
                            }
                        },
                        '添加'
                    ),
                    h(
                        'Button',
                        {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.submitData(h, params)
                                }
                            }
                        },
                        '提交'
                    ),
                    h(
                        'Button',
                        {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.updateData(h, params)
                                }
                            }
                        },
                        '上传'
                    )
                ])
            }
        }
      ],
      mapData: [],
      yubaoPointData: null,
      importExcel: false,
      columns: [
        {
            title: '台风名称',
            key: 'name',
        },
        {
            title: '英文名称',
            key: 'enname',
        },
        {
            title: '台风编码',
            key: 'tfid',
        },
        {
            title: '经度',
            key: 'lng',
        },
        {
            title: '纬度',
            key: 'lat',
        },
        {
            title: '风向',
            key: 'movedirection',
        },
        {
            title: '整体移动速度(km/h)',
            key: 'movespeed',
        },
        {
            title: '风力(级)',
            key: 'power',
        },
        {
            title: '气压(hPa)',
            key: 'pressure',
        },
        {
            title: '10级风力影响半径',
            key: 'radius10',
        },
        {
            title: '7级风力影响半径',
            key: 'radius7',
        },
        {
            title: '风速(m/s)',
            key: 'radius7',
        },
        {
            title: '风力等级描述',
            key: 'strong',
        },
        {
            title: '数据更新时间',
            key: 'date',
        },
      ]

    };
  },
  mounted() {
    for(let i = 0; i < 10; i++){
        this.yearList.push(this.selectYear - i)
    }
    this.initTable()
  },
  watch: {
    map2(a, b) {
      this.initMap2();
    },
    //选择的点id
    selFeatureId(val) {
        // this.mapData.forEach((x, index) => {
        //     if (x.id == val) {
        //         console.log(x)
        //         this.$refs.tabTable.highlightCurrentRow(index)
        //         let table = document.getElementsByClassName('ivu-table-body')
        //         table[0].scrollTop =
        //             (table[0].scrollHeight / this.mapData.length) * index
        //         console.log(table)
        //     }
        // })
        this.typhoonYubaoPointLayer2.features.forEach(x => {
            if (x.attributes.currentId == this.savePoint.currentId && x.attributes.time == this.savePoint.time && x.attributes.forecastAddress == '中大预报') {
                x.style.strokeColor = 'red';
                x.style.strokeWidth = 2;
                console.log(x)
            } else{
                x.style.strokeColor = 'black';
                x.style.strokeWidth = 0.5;
            }
        })
        this.typhoonYubaoPointLayer2.redraw()
    },
    //激活绘制
    isDrawPointActive(val) {
        if (val) {
            this.drawPoint.activate()
        } else this.drawPoint.deactivate()
    },
  },
  methods: {
    //获取白板图组件的地图对象
    getMap2(data) {
      this.map2 = data;
    },
    //初始化地图图层
    initMap2() {
      let t = this;
      t.pointLayer = new WeatherMap.Layer.Vector('pointLayer')
      t.drawPoint = new WeatherMap.Control.DrawFeature(
        t.pointLayer,
        WeatherMap.Handler.Point,
        { multi: true }
      )
      t.map2.addControl(this.drawPoint);
      t.drawPoint.events.on({
            featureadded: t.drawPointFullCompleted
      });
      t.typhoonPointLayer2 = new WeatherMap.Layer.Vector("point");
      t.typhoonLineLayer2 = new WeatherMap.Layer.Vector("Line");
      t.typhoonYubaoPointLayer2 = new WeatherMap.Layer.Vector("yubaoPoint");
      t.typhoonYubaoLineLayer2 = new WeatherMap.Layer.Vector("yubaoLine");
      t.typhoonFengquanLayer2 = new WeatherMap.Layer.Vector("fengquan2");
      t.typhoonContainer2 = new WeatherMap.Layer.Vector.RootContainer(
        "t.typhoonContainer2"
      );
      t.typhoonContainer2.layers = [
        t.typhoonYubaoPointLayer2,
        t.typhoonPointLayer2
      ];
      t.map2.addLayers([
        t.typhoonFengquanLayer2,
        t.typhoonYubaoLineLayer2,
        t.typhoonLineLayer2,
        t.pointLayer,
        t.typhoonYubaoPointLayer2,
        t.typhoonPointLayer2,
        t.typhoonContainer2
      ]);
      t.map2.setLayerIndex(t.typhoonFengquanLayer2, 0);

      let selectFeature2 = new WeatherMap.Control.SelectFeature(
        t.typhoonContainer2,
        {
          callbacks: {
            click: function(currentFeature) {
                if(currentFeature.attributes.type == '台风路径点'){
                    t.addForcastData(currentFeature.attributes);
                }
            }
          }
        }
      );
      selectFeature2.id = "typhoonSelectFeature2";
      t.map2.addControl(selectFeature2);
      selectFeature2.activate();
      t.showTyphoonMap();
    },
    showTyphoonMap() {
      let t = this;
      t.typhoonPointLayer2.removeAllFeatures();
      t.typhoonPointLayer2.removeAllFeatures();
      t.typhoonLineLayer2.removeAllFeatures();
      t.typhoonYubaoLineLayer2.removeAllFeatures();
      t.typhoonYubaoPointLayer2.removeAllFeatures();
        $.get(this.$ipConfig.getTyphoonPathData + "&element=" + t.tfid).then(
          data => {
            $.get(this.$ipConfig.getTypthoonZdybData + "&thisid=" + t.tfid).then(ybData => {
                t.ybList = ybData.dataList;
                let trackData = data.dataList;
                var pointList = [];
                var fengPoint = new WeatherMap.Geometry.Point(
                trackData[trackData.length - 1].lng,
                trackData[trackData.length - 1].lat
                );
                var attribute = trackData[trackData.length - 1];
                attribute.type = "台风路径点";
                attribute.typhoonNum = trackData.length - 1;
                var typhoonlevel = t.getTyphoonInformation(attribute.speed);
                attribute.level = typhoonlevel.name;
                var fengPointVector = new WeatherMap.Feature.Vector(
                fengPoint,
                attribute,
                {
                    externalGraphic: typhoonImg,
                    pointRadius: 30,
                    graphicOpacity: 0.9
                }
                );
                fengPointVector.id = t.tfid + "feng";
                var lineFeatures = [];
                var pointAnimatorList = [];
                var lineVector;
                for (var i = 0; i < trackData.length; i++) {
                  var arr = [];
                  var point = new WeatherMap.Geometry.Point(
                      trackData[i].lng,
                      trackData[i].lat
                  );
                  pointList.push(point);
                  var attribute = trackData[i];
                  attribute.type = "台风路径点";
                  attribute.typhoonNum = i;
                  var typhoonlevel = t.getTyphoonInformation(attribute.speed);
                  attribute.level = typhoonlevel.name;
                  var pointVector = new WeatherMap.Feature.Vector(point, attribute);
                  pointVector.id = t.tfid + trackData[i].time;
                  pointVector.style = {
                      fillColor: typhoonlevel.color,
                      strokeWidth: 0.5,
                      pointRadius: 5
                  };

                  var pointAnimator = new WeatherMap.Feature.Vector(
                      point,
                      attribute
                  );
                  pointAnimator.style = {
                      fillColor: typhoonlevel.color,
                      strokeWidth: 0.5,
                      pointRadius: 5
                  };
                  t.ybList.map(item => {
                    if(item.currentId == trackData[i].currentId){
                      pointAnimator.style = {
                        fillColor: typhoonlevel.color,
                        strokeWidth: 2,
                        pointRadius: 5,
                        strokeColor: 'red'
                      };
                    }
                  })
                  pointAnimatorList.push(pointAnimator);
                  //   typhoonPointList.push(pointVector);
                  // t.typhoonPointLayer.addFeatures([pointVector]);
                  var line = new WeatherMap.Geometry.LineString(pointList);
                  arr.push(line);
                  var multiLineString = new WeatherMap.Geometry.MultiLineString(
                      arr
                  );
                  lineVector = new WeatherMap.Feature.Vector(multiLineString, {
                      FEATUREID: 1,
                      TIME: i
                  });
                  lineVector.id = t.tfid;
                  lineVector.style = {
                      strokeColor: "rgb(0,118,201)",
                      strokeWidth: 2
                  };
                  lineFeatures.push(lineVector);
                }
                var locationPoint = new WeatherMap.LonLat(
                trackData[trackData.length - 1].lng,
                trackData[trackData.length - 1].lat
                );
                t.typhoonPointLayer2.addFeatures(pointAnimatorList);
                t.typhoonPointLayer2.addFeatures([fengPointVector]);
                t.typhoonLineLayer2.addFeatures(lineFeatures);
                t.map2.panTo(locationPoint);
                t.map2.zoomTo(6);

                var yubaoPoint = trackData[trackData.length - 1];
                //风圈
                //圆
                if (yubaoPoint.en7radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.en7radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 270, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        // strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                if (yubaoPoint.es7radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.es7radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 180, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                if (yubaoPoint.ws7radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.ws7radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 90, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                if (yubaoPoint.wn7radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.wn7radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 0, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                //圆
                if (yubaoPoint.en10radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.en10radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 270, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        // strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                if (yubaoPoint.es10radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.es10radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 180, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                if (yubaoPoint.ws10radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.ws10radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 90, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                if (yubaoPoint.wn10radii != null) {
                    var centerPoint = new WeatherMap.Geometry.Point(
                        yubaoPoint.lng,
                        yubaoPoint.lat
                    );
                    var radius = yubaoPoint.wn10radii / 110;
                    var circleP = t.createCircle(centerPoint, radius, 64, 0, 90);
                    var circleVector = new WeatherMap.Feature.Vector(circleP);
                    circleVector.style = {
                        strokeColor: "rgb(224,172,82)",
                        fillColor: "rgb(224,172,82)",
                        strokeWidth: 1,
                        fillOpacity: 0.4,
                        stroke: false
                    };
                    t.typhoonFengquanLayer2.addFeatures([circleVector]);
                }
                t.addForcastData(trackData[trackData.length - 1])
            })
          }
        );
    },
    //显示某个点的预报路径
    addForcastData(yubao) {
      let t = this;
      t.yubaoPointData = yubao;
      t.mapData = [];
      $.get(
        this.$ipConfig.getLastTypthoonForData +
          "&thisid=" +
          yubao.currentId
      ).then(data => {
        t.ybList = data.dataList;
        t.ybList.map(item => {
            if (item.currentId == yubao.currentId && item.forecastAddress == '中大预报') {
                item.isEdit = false;
                item.date = moment(item.time).format('YYYY-MM-DD HH:mm:ss')
                let a = $.extend('', item)
                t.mapData.push(a);
            }
        });
        if(t.mapData.length == 0){
            t.$Message.error({
                content: '该实况点暂无中大预报路径',
                duration: 4
            });
        }
        t.addTyphoonForcastdata();
      });
    },
    addTyphoonForcastdata(){
      let t = this;
      let list = [];
      let yubao = t.yubaoPointData;
      let yubaoList = {};
      t.ybList.map(item => {
        if (!yubaoList[item.forecastAddress]) {
          yubaoList[item.forecastAddress] = [];
          yubaoList[item.forecastAddress].push(yubao);
        }
        yubaoList[item.forecastAddress].push(item);
      });
      var point;
      t.typhoonYubaoPointLayer2.removeAllFeatures();
      t.typhoonYubaoLineLayer2.removeAllFeatures();
      Object.keys(yubaoList).map(e => {
        let list = yubaoList[e];
        if (!$('input[value="' + e + '"]').is(":checked")) list = [];
        var pointList = [];
        for (var j = 0; j < list.length; j++) {
          if (j == 0 && list[j].lng != 9999) {
            point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
          } else {
            if (j == 0) {
              point = new WeatherMap.Geometry.Point(yubao.lng, yubao.lat);
              pointList.push(point);
            }
            point = new WeatherMap.Geometry.Point(list[j].lng, list[j].lat);
          }
          pointList.push(point);
          var attribute = list[j];
          attribute.type = "台风预报点";
          if(j == 0) {
            attribute.type = "台风路径点";
          }
          var pointVector = new WeatherMap.Feature.Vector(point, attribute);
          var color = t.getTyphoonPointColor(attribute.speed);
          pointVector.name = attribute.tfid;
          pointVector.style = {
            fillColor: color,
            strokeWidth: 0.5,
            pointRadius: 5
          };
          t.typhoonYubaoPointLayer2.addFeatures([pointVector]);
        }
        var line = new WeatherMap.Geometry.LineString(pointList);
        var lineVector = new WeatherMap.Feature.Vector(line);
        var lineColor = "red";
        if (list.length != 0) {
          lineColor = t.getTyphoonYubaoLine(list[1].forecastAddress);
        }
        lineVector.style = {
          strokeColor: lineColor,
          strokeDashstyle: "dash",
          strokeWidth: 2
        };
        lineVector.name = yubao.tfid;
        t.typhoonYubaoLineLayer2.addFeatures([lineVector]);
      });
    },
    getTyphoonYubaoLine(value) {
      if (value == "中国") {
        return "#FF6450";
      } else if (value == "日本") {
        return "#43FF4B";
      } else if (value == "美国") {
        return "#40DDFF";
      } else if (value == "中国台湾") {
        return "#FFA040";
      } else if (value == "中国香港") {
        return "#FF66FF";
      } else if (value == "欧洲") {
        return "#373591";
      } else if (value == "中大预报") {
        return "#FF0000";
      } else if (value == "韩国") {
        return "#669999";
      } else {
        return "red";
      }
    },
    getTyphoonInformation(speed) {
      var color;
      var name;
      if (speed > 51.0) {
        color = "rgb(219,0,0)";
        name = "超强台风";
      } else if (speed >= 42.5 && speed < 51.0) {
        color = "rgb(255,0,255)";
        name = "强台风";
      } else if (speed >= 32.7 && speed < 42.5) {
        color = "rgb(255,117,0)";
        name = "台风";
      } else if (speed >= 24.5 && speed < 32.7) {
        color = "rgb(255,255,0)";
        name = "强热带风暴";
      } else if (speed >= 17.2 && speed < 24.5) {
        color = "rgb(64,151,239)";
        name = "热带风暴";
      } else if (speed < 17.2) {
        color = "rgb(0,141,0)";
        name = "热带低压";
      }
      return { color: color, name: name };
    },
     //圆
    createCircle(origin, radius, sides, r, angel) {
      var rR = (90 * Math.PI) / (180 * sides);
      var rotatedAngle, x, y;
      var points = [];
      for (var i = 0; i < sides; ++i) {
        rotatedAngle = (r * Math.PI) / 180 + rR * i;
        x = origin.x + radius * Math.cos(rotatedAngle);
        y = origin.y + radius * Math.sin(rotatedAngle);
        points.push(new WeatherMap.Geometry.Point(x, y));
      }
      rotatedAngle = ((r + 90) * Math.PI) / 180;
      x = origin.x + radius * Math.cos(rotatedAngle);
      y = origin.y + radius * Math.sin(rotatedAngle);
      points.push(new WeatherMap.Geometry.Point(x, y));
      points.push(origin);

      var ring = new WeatherMap.Geometry.LinearRing(points);
      ring.rotate(parseFloat(angel), origin);
      var geo = new WeatherMap.Geometry.Collection([ring]);
      geo.origin = origin;
      geo.radius = radius;
      geo.r = r;
      geo.angel = angel;
      geo.sides = sides;
      geo.polygonType = "Curve";
      return geo;
    },
    getTyphoonPointColor(speed) {
      var color;
      if (speed > 51.0) color = "rgb(219,0,0)";
      else if (speed >= 42.5 && speed < 51.0) color = "rgb(255,0,255)";
      else if (speed >= 32.7 && speed < 42.5) color = "rgb(255,117,0)";
      else if (speed >= 24.5 && speed < 32.7) color = "rgb(255,255,0)";
      else if (speed >= 17.2 && speed < 24.5) color = "rgb(64,151,239)";
      else if (speed < 17.2) color = "rgb(0,141,0)";
      return color;
    },
    initTable(){
        let t = this;
        layui.use('table', function () {
            var table = layui.table;
            table.render({
                elem: '#focastData',
                url: t.$ipConfig.getHisTyphoonData + '&starttime=' + t.selectYear,
                method: 'post',
                response: {
                    statusCode: 999 //重新规定成功的状态码为 200，table 组件默认为 0
                },
                parseData: function (res) { //res 即为原始返回的数据
                    return {
                    "code": res.status, //解析接口状态
                    "msg": res.message, //解析提示文本
                    "data": res.dataList //解析数据列表
                    };
                },
                // toolbar: '#toolbarDemo2', //开启头部工具栏，并为其绑定左侧模板
                defaultToolbar: [''],
                title: '用户数据表',
                cols: [[
                    {type: 'numbers', title: '序号', width: 80, align:'center', sort: true}
                    , {field: 'tfid', title: '台风编号', align:'center'}
                    , {field: 'name', title: '台风名称', align:'center'}
                    , {field: 'enname', title: '英文名称', align:'center'}
                    , {title: '操作', align:'center', toolbar: '#barDemo2', width: 200}
                ]],
                id: 'focastDataReload',
                page: false
            });

            //监听行工具事件
            table.on('tool(focastData)', function (obj) {
                var data = obj.data;
                //console.log(obj)
                if (obj.event === 'export') {
                  $.post(t.$ipConfig.getTyphoonPathData + `&element=${data.tfid}`).then(function(skData){

                        $.post(t.$ipConfig.getHisForTyphoon + `&thisid=${data.tfid}`).then(function(yubaoData){
                          skData.dataList.map(item => {
                            item.date = moment(item.time).format('YYYYMMDDHHmm');
                          })
                          let excelData = {
                            '中国': [],
                            '中国香港': [],
                            '中国台湾': [],
                            '日本': [],
                            '美国': [],
                            '韩国': [],
                            '欧洲': [],
                            '中大预报': []
                          }
                          yubaoData.dataList.reverse();
                          yubaoData.dataList.map(item => {
                            item.date = moment(item.time).format('YYYYMMDDHHmm');
                            skData.dataList.map(e => {
                              if(item.currentId == e.currentId){
                                item.forcastDate = e.date;
                              }
                            })
                            if(excelData[item.forecastAddress].length > 0 && item.currentId != excelData[item.forecastAddress][excelData[item.forecastAddress].length - 1].currentId){
                              excelData[item.forecastAddress].push({})
                            }
                            item.movespeed = 0;
                            excelData[item.forecastAddress].push(item)
                          })
                          let dic = [];
                          let columns2 = [
                            {
                                title: '发布时间',
                                key: 'forcastDate',
                            },
                            {
                                title: '预达时间',
                                key: 'date',
                            },
                            {
                                title: '台风编码',
                                key: 'tfid',
                            },
                            {
                                title: '经度',
                                key: 'lng',
                            },
                            {
                                title: '纬度',
                                key: 'lat',
                            },
                            {
                                title: '风向',
                                key: 'movedirection',
                            },
                            {
                                title: '整体移动速度(km/h)',
                                key: 'movespeed',
                            },
                            {
                                title: '风力(级)',
                                key: 'power',
                            },
                            {
                                title: '气压(hPa)',
                                key: 'pressure',
                            },
                            {
                                title: '10级风力影响半径',
                                key: 'radius10',
                            },
                            {
                                title: '7级风力影响半径',
                                key: 'radius7',
                            },
                            {
                                title: '风速(m/s)',
                                key: 'radius7',
                            },
                            {
                                title: '风力等级描述',
                                key: 'strong',
                            },
                          ];
                          dic = [{ sheetName: "实况路径", col: t.columns, data: skData.dataList }];
                          Object.keys(excelData).map(value => {
                            if(excelData[value].length > 0){
                              dic.push({ sheetName: excelData[value][0].forecastAddress, col: columns2, data: excelData[value] })
                            }
                          })
                          let name = "台风(" + data.name + ')详细数据' + moment().format('YYYY-MM-DD');
                          t.exportExcelPuls(dic, name);
                          layer.close(index);
                      })
                  })
                } else if (obj.event === 'edit') {
                    t.tfid = data.tfid;
                    t.modal = true;
                }
            });
        });
    },
    changeYear() {
        this.initTable();
    },
    exportData() {

    },
    cancel() {

    },
    // 绘制完成事件
    drawPointFullCompleted(msg) {
        // this.isDrawPointActive = false
        let t = this;
        if (this.savePoint !== null) {
            this.pointLayer.features.forEach(item => {
                if (item.attributes.currentId == this.savePoint.currentId && item.attributes.time == this.savePoint.time) {
                    this.pointLayer.removeFeatures(item)
                }
            })
        }
        msg.feature.geometry.x = msg.feature.geometry.components[0].x.toFixed(6)
        msg.feature.geometry.y = msg.feature.geometry.components[0].y.toFixed(6)
        this.mapData.map(item => {
            if(item.currentId == t.savePoint.currentId && moment(item.date).format('YYYY-MM-DD HH:mm:ss') == moment(t.savePoint.date).format('YYYY-MM-DD HH:mm:ss')){
                item.lng = msg.feature.geometry.components[0].x.toFixed(6);
                item.lat = msg.feature.geometry.components[0].y.toFixed(6);
            }
        })
        this.ybList.map(item => {
            if(item.currentId == t.savePoint.currentId && moment(item.date).format('YYYY-MM-DD HH:mm:ss') == moment(t.savePoint.date).format('YYYY-MM-DD HH:mm:ss') && item.forecastAddress == '中大预报'){
                item.lng = msg.feature.geometry.components[0].x.toFixed(6);
                item.lat = msg.feature.geometry.components[0].y.toFixed(6);
            }
        })
        this.addTyphoonForcastdata()
        // this.mapData[this.savePoint].lon = msg.feature.geometry.components[0].x
        // this.mapData[this.savePoint].lat = msg.feature.geometry.components[0].y
        // this.mapData[this.savePoint].isEdit = false
        // this.mapData[this.savePoint].id = msg.feature.id
        // this.map.setCenter(
        //     new WeatherMap.LonLat(
        //         msg.feature.geometry.components[0].x,
        //         msg.feature.geometry.components[0].y
        //     )
        // )
        this.pointLayer.removeAllFeatures();
    },
    //***********************************************  table  *******************************************/
    // 编辑
    editPoint(row, index) {
        this.savePoint = row
        this.mapData.forEach((x, i) => {
            if (i == index){
                x.isEdit = true
            }  else x.isEdit = false
        })
        this.isDrawPointActive = true //开启画点
        this.selFeatureId = row.time
    },
    // 确定
    pointDefine(row, index) {
        let t = this;
        this.ybList.map(item => {
            if(item.currentId == this.savePoint.currentId && item.time == this.savePoint.time && item.forecastAddress == '中大预报'){
                item.lng = this.mapData[index].lng
                item.lat = this.mapData[index].lat;
            }
        })
        this.addTyphoonForcastdata()
        this.mapData[index].isEdit = false
        this.isDrawPointActive = false //关闭画点
    },
    //添加
    addMapData() {
        this.mapData.push({
            currentId :this.yubaoPointData.currentId,
            isNew: true,
            lat: '',
            lng: '',
            date: '',
            time: '',
            pressure: 0,
            speed: 0,
            movespeed: 0,
            power:0,
            strong: '',
            isEdit: false,
            forecastAddress: '中大预报'
        })
        this.ybList.push({
            currentId :this.yubaoPointData.currentId,
            isNew: true,
            lat: '',
            lng: '',
            date: '',
            time: '',
            pressure: 0,
            speed: 0,
            movespeed: 0,
            power:0,
            strong: '',
            isEdit: false,
            forecastAddress: '中大预报'
        })
    },
    //删除
    remove(row, index) {
        let t = this;
        this.isDrawPointActive = false //关闭画点
        layer.open({
            type: 1,
            title: '删除数据',
            skin: 'layui-layer-rim', //加上边框
            content: '确定删除该点？',
            area: ['200px', '200px'], //宽高
            btn: ['确定','取消'],
            success:function(){
            },
            yes: function () {
                $.post(t.$ipConfig.deleteTyphoonListZdyb + `&starttime=${moment(row.date).format('YYYY-MM-DD HH:mm:ss')}&thisid=${t.tfid}&warnid=${row.currentId}`)
                    .then(data => {
                        if(data.status === 999){
                            t.mapData.splice(index, 1)
                            t.$Message.success('删除成功！');
                            t.addForcastData(t.yubaoPointData);
                        }else{
                            t.$Message.error('删除失败！');
                        }
                    })
                    .fail(x => {
                        t.$Message.error('删除失败！');
                    })
                layer.closeAll(0);
            },
            btn2:function(){
                layer.closeAll(0); //关闭当前窗口
            }
        });

    },
    //提交
    submitData() {
        let me = this;
        let updateArray = [];
        let insertArray = [];
        if (this.mapData.length == 0) {
            this.$Message.warning('请添加数据！')
            return
        }
        this.mapData.forEach(x => {
            x.isEdit = false;
            if(x.isNew){
                insertArray.push(x);
            }else{
                updateArray.push(x);
            }
        })
        let updatePara = {
            Data: [],
        }
        updateArray.forEach(x => {
            updatePara.Data.push({
                thisid: this.tfid,
                Latitude: x.lat,
                Longitude: x.lng,
                gender: x.movespeed,
                PowerValue: x.power,
                PreValues: x.pressure,
                rd10: x.radius10,
                rd7: x.radius7,
                threshold: x.speed,
                datasource: x.strong,
                starttime: moment(x.date).format('YYYY-MM-DD HH:mm:ss'),
                warnid: x.currentId
            })
        })
        let insertPara = {
            Data: [],
        }
        insertArray.forEach(x => {
            insertPara.Data.push({
                thisid: this.tfid,
                Latitude: Number(x.lat),
                Longitude: Number(x.lng),
                gender: Number(x.movespeed),
                PowerValue: Number(x.power),
                PreValues: Number(x.pressure),
                rd10: Number(x.radius10),
                rd7: Number(x.radius7),
                threshold: Number(x.speed),
                datasource: x.strong,
                starttime: moment(x.date).format('YYYY-MM-DD HH:mm:ss'),
                warnid: Number(x.currentId)
            })
        })
        $.post(this.$ipConfig.updateTZDyb, { params: JSON.stringify(updatePara) })
            .then(data => {
                $.post(this.$ipConfig.insertTyphoonListZdyb, { params: JSON.stringify(insertPara) })
                .then(data => {
                    this.$Message.success('保存成功！');
                    this.addForcastData(this.yubaoPointData);
                })
                .fail(x => {
                    this.$Message.error('保存失败！');
                })
            })
            .fail(x => {
                this.$Message.error('保存失败！');
            })
    },
    updateData(h, params){
        this.importExcel = true;
    },
    importfxx(obj) {
      let _this = this;
    //   console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxx1");
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据

      this.file = event.currentTarget.files[0];

      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;

      var reader = new FileReader();
      //if (!FileReader.prototype.readAsBinaryString) {
      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function(e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary"
            });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
          outdata.map((item,index) => {
            if(index > 0){
                let time = item['预达时间（年月日时）'] + '';
                let date = time.substring(0, 4) + '-' + time.substring(4, 6) + '-' + time.substring(6, 8) + ' ' + time.substring(8, 10) + ':00:00';
                //添加
                _this.mapData.push({
                    currentId :_this.yubaoPointData.currentId,
                    isNew: true,
                    lat: item['纬度'],
                    lng: item['经度'],
                    date: moment(date).format('YYYY-MM-DD HH:mm:ss'),
                    time: '',
                    pressure: item['中心气压（百帕）'],
                    speed: item['风速（米/秒）'],
                    movespeed: 0,
                    power:0,
                    strong: '',
                    isEdit: false,
                    forecastAddress: '中大预报'
                })
                _this.ybList.push({
                    currentId :_this.yubaoPointData.currentId,
                    isNew: true,
                    lat: item['纬度'],
                    lng: item['经度'],
                    date: moment(date).format('YYYY-MM-DD HH:mm:ss'),
                    time: '',
                    pressure: item['中心气压（百帕）'],
                    speed: item['风速（米/秒）'],
                    movespeed: 0,
                    power:0,
                    strong: '',
                    isEdit: false,
                    forecastAddress: '中大预报'
                })
                _this.addTyphoonForcastdata();
                _this.importExcel = false;
            }
          })
          _this.$Message.info('数据导入成功！')
          console.log(outdata)
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    // 导出表格(vue+iview,改良版)
    exportExcelPuls(dic, name) {
      /*
      参数格式及描述
      dic:[
    	{sheetName:"",col:[],data:[]},
        {sheetName:"",col:[],data:[]},
        {sheetName:"",col:[],data:[]},
        ...
        ]，分别为每页的表名，iview表格列的配置描述，请求到的数据
       name：字符串，导出的Excel文件名
      }
      */
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("../common/export2Excel"); //这个地址和页面的位置相关，这个地址是 Export2Excel. js相对于页面的相对位置

        let tableData = [];
        dic.forEach((item, index) => { //整理数据
          tableData[index] = {};
          tableData[index]["sheetName"] = item.sheetName;
          tableData[index]["titles"] = [];
          tableData[index]["keys"] = [];
          for (var i = 0; i < item.col.length; i++) {
            if (item.col[i].slot) {
              tableData[index]["titles"].push(item.col[i].title);
              tableData[index]["keys"].push(item.col[i].slot);
              //如果有插槽，插槽名要和对应的key一样，如不一样需修改代码
            } else {
              if (item.col[i].children) {//判断是否有表头合并
                item.col[i].children.forEach(j => {
                  tableData[index]["titles"].push(
                    item.col[i].title + "-" + j.title
                  );
                  tableData[index]["keys"].push(j.key);
                });
              } else {
                tableData[index]["titles"].push(item.col[i].title);
                tableData[index]["keys"].push(item.col[i].key);
              }
            }
          }
        });

        tableData.forEach((item, index) => {
          tableData[index]["data"] = this.formatJson(
            item.keys,
            dic[index].data
          );
          delete item.keys;
        });
        export_json_to_excel(tableData, name);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style scoped>
#item3 {
  width: 100%;
  height: 100%;
}
.layui-table-body {
  overflow-x: hidden;
}
/* table {
  width: 100%;
  display: table;
} */
.editDiv {
  height: 100%;
}
.map_tool {
  width: 900px;
  min-width: 350px;
  position: absolute;
  left: 16px;
  top: 16px;
  z-index: 99999999;
}
.map_table {
  width: 700px;
  min-width: 350px;
  position: sticky;
  right: 0;
  top: 0;
  left: 395px;
  bottom: 25px;
  z-index: 99999999;
}
.map_table .ivu-input-small {
  font-weight: bold;
  font-size: 12px;
  text-align: left;
}
.map_table .ivu-row:not(:last-child) {
  border-bottom: none;
}
.map_table .ivu-col-span-18,
.map_table .ivu-col-span-8 {
  text-align: left;
  padding: 0 5px;
}
.map_table .ivu-col-span-6,
.map_table .ivu-col-span-8 {
  border-right: 2px solid black;
}
.map_table .ivu-col-span-6 {
  text-align: left;
  padding: 0 5px;
}

/* row */
.map_tool {
  background: #fff;
}
.map_tool table {
  display: table;
  table-layout: fixed !important;
}
.map_tool .ivu-table-small td {
  height: 30px;
}
.ivu-table-row-highlight td {
  background-color: #8eb2f9;
}
/* .map_tool .ivu-table-body {
  overflow: overlay !important;
} */
/* .map_tool .ivu-table-overflowX {
	overflow: hidden;
} */
.map_tool .ivu-table-wrapper {
  border-right: 1px solid #dcdee2;
}
.map_tool .ivu-table:after {
  background-color: #3071b8;
  width: 0px;
}
.map_tool .ivu-table-cell {
  padding-left: 2px;
  padding-right: 2px;
  white-space: nowrap !important;
  /* overflow: hidden !important; */
  /* text-overflow: ellipsis !important; */
}
#Legend{
    height: 200px;
    width: 250px;
    position: absolute;
    z-index: 1000;
    bottom: 0;
    left: 17px;
}
</style>



// WEBPACK FOOTER //
// src/common/focastData.vue